module.exports = __webpack_public_path__ + "img/icon-search@2x.37afc479.png";